<template>
  <div class="mt-5">
    <h5>Validation Policy :</h5>
    <b-form-input v-model="policy.name" type="text" placeholder="Enter policy name" class="mb-2"></b-form-input>
    <b-form-textarea id="textarea1"
       v-model="policy.policy"
       placeholder="Enter Validation Policy in JSON format"
       :rows="6">
    </b-form-textarea>
    <blockquote>
      <h6>Operator List:</h6>
      <code>equal, notEqual, greater, less, contain, null, notNull</code>
      <h6>Sample:</h6>
      <code>[{"or": true, "path": "questions.fieldName.yesOrNo", "operator": "contain", "value": "Yes","required": true}]</code>
    </blockquote>
    <div class="custom-control custom-checkbox mr-sm-2 mb-3">
      <input type="checkbox" class="custom-control-input" id="checkbox0" value="check" v-model="policy.status">
      <label class="custom-control-label" for="checkbox0">Enabled</label>
    </div>
    <div class="">
      <button class="btn btn-info" @click="update">
        Save Policy
      </button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import pick from 'lodash/pick';
  import CAMPAIGN_POLICY from '@/graphql/Campaigns/CampaignPolicy.gql';
  import CAMPAIGN_POLICY_CREATE from '@/graphql/Campaigns/CampaignPolicyCreate.gql';
  import CAMPAIGN_POLICY_EDIT from '@/graphql/Campaigns/CampaignPolicyEdit.gql';

  export default {
    name: "CampaignPolicy",
    props: { campaignId: Number },
    data() {
      return {
        policy: {
          created: null,
          updated: null,
          status: false,
          policy: '',
          name: null,
        },
        campaignPolicy: null,
      };
    },
    methods: {
      async update() {
        // Object.assign(this.campaignPolicy, this.policy);
        try {
          await this.$apollo.mutate({
            mutation: (this.campaignPolicy) ? CAMPAIGN_POLICY_EDIT : CAMPAIGN_POLICY_CREATE,
            variables: {
              campaignId: this.campaignId,
              input: pick(this.policy, ['status', 'policy', 'name']),
            },
          });
          this.$notify({
            type: 'success',
            group: 'success',
            text: 'Policy Saved',
          });
          this.$apollo.queries.campaignPolicy.refetch()
        } catch (e) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        }
      },
    },
    apollo: {
      campaignPolicy: {
        query: CAMPAIGN_POLICY,
        loadingKey: 'showSpinner',
        fetchPolicy: 'network-only',
        variables() {
          return {
            campaignId: this.campaignId,
          };
        },
        result({ data, loading }) {
          if (loading) {
            return;
          }
          if (data.campaignPolicy) {
            Vue.set(this, 'policy', { ...data.campaignPolicy });
            this.$emit('created', Boolean(data.campaignPolicy));
          }
        },
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/CampaignPolicy.vue